import AWS from 'aws-sdk';
import {isLoggedIn} from './auth0.js';
import sigV4Client from "./sigV4Client";
import config from '../config';
import axios from 'axios';

export default async function({endpoint, path="/", method="GET", headers={}, queryParams={}, body}) {
  let results;

  if (
    (endpoint.indexOf('/booking') !== -1 && (path != '/list' && path.indexOf('/archive') === -1))
    ||
    (endpoint.indexOf('/offer') !== -1)
    ||
    (endpoint.indexOf('/owners') !== -1 && (path.indexOf('/save/') !== -1 || path.indexOf('/fromapplicant/') !== -1 || path.indexOf('/toapplicant/') !== -1))
  ) { // booking API calls with no need for authentication
    results = await axios({
  		method,
  		url: endpoint+path,
  		data: body
  	});

    if (results.status !== 200) {
  		throw new Error(await results.text());
  	}

  	return results.data;
  }

	// check if logged in
	if(!await isLoggedIn()) {
		throw new Error("User is not logged in!");
	}

	// get signed request
	const signedRequest = sigV4Client.newClient({
		accessKey: AWS.config.credentials.accessKeyId,
		secretKey: AWS.config.credentials.secretAccessKey,
		sessionToken: AWS.config.credentials.sessionToken,
		region: 'eu-west-2',
		endpoint: endpoint
	}).signRequest({
		method,
		path,
		headers,
		queryParams,
		body
	});

	// get headers and body
	headers = signedRequest.headers;
	body = body ? JSON.stringify(body) : body;

	// fetch data
	results = await axios({
		method,
		url: signedRequest.url,
		headers,
		data: body
	});

	if (results.status !== 200) {
		throw new Error(await results.text());
	}

	return results.data;
}



// WEBPACK FOOTER //
// ./src/libs/api.js